import api from './api.service';

export interface Container {
  id: string;
  tenant_id: string;
  resource_type: 'container';
  name: string;
  hostname?: string;
  ip_address?: string;
  cloud_provider?: string;
  cloud_region?: string;
  tags?: {
    image?: string;
    container_id?: string;
    ports?: string[];
    restart_count?: number;
    host_id?: string;
    host_name?: string;
    compose_project?: string;
    compose_service?: string;
    [key: string]: any;
  };
  status: 'online' | 'offline' | 'degraded' | 'unknown';
  last_heartbeat_at?: string;
  created_at: string;
  updated_at: string;
}

export const containerApi = {
  getContainers: async (limit: number = 50, offset: number = 0): Promise<{ data: Container[]; meta: { total: number; limit: number; offset: number } }> => {
    const response = await api.get<{ success: boolean; data: Container[]; meta: { total: number; limit: number; offset: number } }>(
      `/v1/infrastructure/containers?limit=${limit}&offset=${offset}`
    );
    return { data: response.data, meta: response.meta };
  },

  getContainer: async (id: string): Promise<Container> => {
    const response = await api.get<{ success: boolean; data: Container }>(`/v1/infrastructure/containers/${id}`);
    return response.data;
  },
};
